import { ThunkAction } from 'redux-thunk';
import { Action, Dispatch, ActionCreator } from 'redux';

import { AppState } from '../index';
import { Action as FetchAction, ActionTypes } from './types';

import { getPermissions } from '../../services/permissions';
import { getUserData } from '../../services/localSorage';

export const fetchPermissions: ActionCreator<ThunkAction<void, AppState, null, Action<FetchAction>>> =
  () =>
    async (dispatch: Dispatch<FetchAction>): Promise<void> => {
      try {
        const { user, token } = getUserData();

        if (!user && !token) return;

        dispatch({
          type: ActionTypes.FETCH,
        });

        const permissions = await getPermissions(Number(user?.id), String(token));

        dispatch({
          type: ActionTypes.FETCH_SUCCESS,
          permissions,
        });
      } catch (catchError) {
        dispatch({
          type: ActionTypes.FETCH_ERROR,
        });
      }
    };
